import carousel from '../components/carousel';
import onNowLandscapeCarousel from '../components/onNowLandscapeCarousel';
import contentHighlightCarousel from '../components/highlight/carousel/ContentHighlightCarousel';
import urlHelper from 'helpers/UrlHelper';
import carouselWrapperTpl from 'templates/carousels/wrapper.tpl';
import { MODEL_CHARACTER_CAROUSEL } from 'shared/constants';

const ONNOW = 'On Now';
export default function presearchCarousels() {
    try {
        let presearchComponents = document.querySelector('.presearch-components');
        let fallbackPresearchComponents = document.querySelector('.fallback-presearch-components');

        if (presearchComponents) {
            presearchComponents.innerHTML = '';
        }

        if (fallbackPresearchComponents) {
            fallbackPresearchComponents.style.display = 'none';
        }
        
        $(presearchConfig).each((index, carouselData) => {
    
            // kids carousel class
            if (carouselData.model === MODEL_CHARACTER_CAROUSEL) {
                carouselData.customClass = 'kids-carousel';
            }
            
            let $wrapper = $(carouselWrapperTpl(carouselData));
            if ($wrapper.length) {
                document
                    .querySelector('.presearch-components')
                    .insertAdjacentElement('beforeend', $wrapper.get(0));

                let $carouselElement =
                    $wrapper.find('.js-video-carousel') ?? $wrapper.find('.carousel');
                let userState = CBS.Registry.user_auth ? 'rg' : 'an';
                let _regionPrefix = CBS.Registry.region.prefix;
                let carouselTypePath = CBS.Registry?.user?.profile_type?.toUpperCase() !== 'ADULT' ? 'collections' : 'homepage'; 
                let token = carouselData.token;
                let baseEndpoint =
                    _regionPrefix +
                    '/carousels/' + carouselTypePath + '/configItems/' +
                    userState +
                    '/' +
                    encodeURIComponent(token) +
                    '/offset/{offset}/limit/{limit}/';
                baseEndpoint = urlHelper.appendBundleStatusAndPackageCode(baseEndpoint);
                let options = {
                    endPoint: baseEndpoint, //----- THIS MUST BE ROUTE AND RETURN ENDPOINT DATA
                    params: {
                        slug: carouselData.slug ?? carouselData.dataCi ?? '',
                        sectionId: carouselData.sectionId ?? carouselData.carouselId ?? '',
                    },
                    contentHighlight: carouselData.isContentHighlightEnabled ?? false,
                };
                if (carouselData?.title === ONNOW) {
                    onNowLandscapeCarousel({
                        parentContainer: $carouselElement,
                        size: 'small',
                    });
                } else if (CBS.Registry.Features.content_highlight_web_search && options?.contentHighlight === true) {
                    contentHighlightCarousel({
                        orientation: carouselData.orientation,
                        parentContainer: $carouselElement[0],
                        options: options,
                    });
                } else {
                    carousel({
                        orientation: carouselData.orientation,
                        parentContainer: $carouselElement,
                        options: options,
                    });
                }
            }
        });
    } catch (e) {
        console.error('Pre-Search Carousels failed to load: ', e);
    }
}
